export const HTTP_METHODS = {
    GET: 'GET',
    PATCH: 'PATCH',
    POST: 'POST',
    DELETE: 'DELETE',
};

export const HTTP_RESPONSE_CODE = {
    NO_CONTENT: 204,
    BAD_RESPONSE: 400,
    UNAUTHORIZED: 401,
    REQUEST_TIMEOUT: 408,
    CONFLICT: 409,
    SERVER_ERROR: 500,
    GATEWAY_ERROR: 502,
    GATEWAY_TIMEOUT: 504,
};

export const DEFAULT_MAX_RETRY_ATTEMPTS = 30;
export const DEFAULT_MIN_RETRY_DELAY_MS = 300;
export const AR_TRO_RETRY_ATTEMPTS = 2;
export const VERIFICATION_RETRY_ATTEMPTS = 3;
